// Valid Time Formats are: HH:mm or HH
// The first check is for when we are backspacing from HH:m, HH: must be valid at that point
export const validateTimeFormat = (lastValue, newValue) => {
    const hoursAndMinutesRegex = /^\d{0,2}?\:\d{0,2}$/;
    const hoursOnlyRegex = /^\d{0,2}?$/;
    let isValid = hoursAndMinutesRegex.test(newValue) || hoursOnlyRegex.test(newValue);
    let value = newValue;
    if (isValid) {
        // Add or remove the colon as required
        if (value.length === 2 && lastValue.length !== 3 && value.indexOf(':') === -1) {
            value = value + ':';
        }
        // when we are backspacing from HH: to HH, remove the last H from the value
        if (value.length === 2 && lastValue.length === 3) {
            value = value.slice(0, 1);
        }
        // finally check the length
        if (value.length > 5) {
            isValid = false;
        }
    }
    return {
        isValid,
        value,
    };
};
// Completed time format is HH:mm OR empty string
export const isCompletedTimeFormat = (time) => {
    const timeRegex = /^\d{2}\:\d{2}$/;
    return timeRegex.test(time);
};
export const isValidTime = (time) => {
    // if not set
    if (!time) {
        return true;
    }
    // check if completed string format
    if (!isCompletedTimeFormat(time)) {
        return false;
    }
    const [hrStr, minStr] = time.split(':');
    // Check if hours is not between 0 and 24
    if (hrStr && hrStr.length && (parseInt(hrStr, 10) < 0 || parseInt(hrStr, 10) > 23)) {
        return false;
    }
    // Check if minutes is not between 0 and 59
    if (minStr && minStr.length && (parseInt(minStr, 10) < 0 || parseInt(minStr, 10) > 59)) {
        return false;
    }
    return true;
};
export const onCloseTimeDialogValidation = (from, to) => {
    let isFromInvalid = false;
    let isToInvalid = false;
    if (!from && to) {
        isFromInvalid = true;
    }
    else if (!to && from) {
        isToInvalid = true;
    }
    return {
        isFromInvalid,
        isToInvalid,
    };
};
export const onCloseNumberRangeValidation = (from, to) => {
    let isFromInvalid = false;
    let isToInvalid = false;
    if (from && to && !isValidRange(from, to)) {
        isFromInvalid = true;
        isToInvalid = true;
    }
    return {
        isFromInvalid,
        isToInvalid,
    };
};
// Valid number formats are: 0.00 or 0
// The first check is for when we are backspacing from HH:m, HH: must be valid at that point
export const validateLMaxFormat = (lastValue, newValue) => {
    let isValid = !isNaN(Number(newValue));
    if (isValid) {
        // validate length and decimal place
        const [num, decimal] = newValue.split('.');
        if (typeof decimal !== 'undefined' && decimal.length > 2) {
            isValid = false;
        }
        if (num === '-0' || num.length > 3) {
            isValid = false;
        }
    }
    return {
        isValid,
        value: newValue,
    };
};
// Completed time format is 0, 0.0, 0.00 or empty
export const isCompletedNumberFormat = (value) => {
    return !isNaN(Number(value));
};
export const isValidDecibel = (value, min, max) => {
    // if not set
    if (!value) {
        return true;
    }
    // check if completed string format
    if (!isCompletedNumberFormat(value)) {
        return false;
    }
    const [num, decimal] = value.split('.');
    if (typeof decimal !== 'undefined' && decimal.length > 2) {
        return false;
    }
    if (num && typeof decimal !== 'undefined' && !decimal) {
        return false;
    }
    if (min !== null && max !== null) {
        if (Number(value) < min || Number(value) > max) {
            return false;
        }
    }
    return true;
};
// Valid number format is 0
// The first check is for when we are backspacing from HH:m, HH: must be valid at that point
export const validateSecondsFormat = (lastValue, newValue) => {
    let isValid = !isNaN(Number(newValue));
    if (isValid) {
        if (newValue.length > 3 || newValue.indexOf('-') !== -1 || newValue.indexOf('.') !== -1) {
            isValid = false;
        }
    }
    return {
        isValid,
        value: newValue,
    };
};
export const isValidSeconds = (value) => {
    // if not set
    if (!value) {
        return true;
    }
    // check if completed string format
    if (!isCompletedNumberFormat(value)) {
        return false;
    }
    if (Number(value) < 0 || Number(value) > 240) {
        return false;
    }
    return true;
};
export const isValidRange = (from, to) => {
    if (Number(from) > Number(to)) {
        return false;
    }
    return true;
};
//# sourceMappingURL=helper.js.map